import {trans} from '../../../../helpers'

// Ссылка на лицензию компании.
export function VnCompanyLicenseLink() {

    // noinspection CheckImageSize
    return (
        <a
            href="http://online.gov.vn/nen-tang/57039064-efa3-4e09-860f-60227a508c1c"
            target="_blank"
            rel="noreferrer"
        >
            <img
                src="/img/licensed-ccdv-logo.png"
                height="50"
                alt={trans().common.footer.licensed}
                className="align-top"
                loading="lazy"
            />
        </a>
    )
}
